// source: kioskService.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.kioskPB.Address', null, global);
goog.exportSymbol('proto.kioskPB.Availability', null, global);
goog.exportSymbol('proto.kioskPB.AvailabilitySchedule', null, global);
goog.exportSymbol('proto.kioskPB.GetKiosksRequest', null, global);
goog.exportSymbol('proto.kioskPB.GetKiosksRequest.RequestTypeCase', null, global);
goog.exportSymbol('proto.kioskPB.GetKiosksResponse', null, global);
goog.exportSymbol('proto.kioskPB.GetKiosksResponse.ResponseTypeCase', null, global);
goog.exportSymbol('proto.kioskPB.Kiosk', null, global);
goog.exportSymbol('proto.kioskPB.KioskSummary', null, global);
goog.exportSymbol('proto.kioskPB.KiosksList', null, global);
goog.exportSymbol('proto.kioskPB.Location', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kioskPB.GetKiosksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.kioskPB.GetKiosksRequest.oneofGroups_);
};
goog.inherits(proto.kioskPB.GetKiosksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kioskPB.GetKiosksRequest.displayName = 'proto.kioskPB.GetKiosksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kioskPB.GetKiosksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.kioskPB.GetKiosksResponse.oneofGroups_);
};
goog.inherits(proto.kioskPB.GetKiosksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kioskPB.GetKiosksResponse.displayName = 'proto.kioskPB.GetKiosksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kioskPB.Address = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kioskPB.Address, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kioskPB.Address.displayName = 'proto.kioskPB.Address';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kioskPB.Location = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kioskPB.Location, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kioskPB.Location.displayName = 'proto.kioskPB.Location';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kioskPB.Kiosk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.kioskPB.Kiosk.repeatedFields_, null);
};
goog.inherits(proto.kioskPB.Kiosk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kioskPB.Kiosk.displayName = 'proto.kioskPB.Kiosk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kioskPB.KioskSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.kioskPB.KioskSummary.repeatedFields_, null);
};
goog.inherits(proto.kioskPB.KioskSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kioskPB.KioskSummary.displayName = 'proto.kioskPB.KioskSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kioskPB.KiosksList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.kioskPB.KiosksList.repeatedFields_, null);
};
goog.inherits(proto.kioskPB.KiosksList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kioskPB.KiosksList.displayName = 'proto.kioskPB.KiosksList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kioskPB.AvailabilitySchedule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kioskPB.AvailabilitySchedule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kioskPB.AvailabilitySchedule.displayName = 'proto.kioskPB.AvailabilitySchedule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.kioskPB.Availability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.kioskPB.Availability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.kioskPB.Availability.displayName = 'proto.kioskPB.Availability';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.kioskPB.GetKiosksRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.kioskPB.GetKiosksRequest.RequestTypeCase = {
  REQUEST_TYPE_NOT_SET: 0,
  EMPTY_REQUEST: 1,
  KIOSK_ID: 2
};

/**
 * @return {proto.kioskPB.GetKiosksRequest.RequestTypeCase}
 */
proto.kioskPB.GetKiosksRequest.prototype.getRequestTypeCase = function() {
  return /** @type {proto.kioskPB.GetKiosksRequest.RequestTypeCase} */(jspb.Message.computeOneofCase(this, proto.kioskPB.GetKiosksRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kioskPB.GetKiosksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.kioskPB.GetKiosksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kioskPB.GetKiosksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.GetKiosksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
emptyRequest: (f = msg.getEmptyRequest()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
kioskId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kioskPB.GetKiosksRequest}
 */
proto.kioskPB.GetKiosksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kioskPB.GetKiosksRequest;
  return proto.kioskPB.GetKiosksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kioskPB.GetKiosksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kioskPB.GetKiosksRequest}
 */
proto.kioskPB.GetKiosksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setEmptyRequest(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKioskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kioskPB.GetKiosksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kioskPB.GetKiosksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kioskPB.GetKiosksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.GetKiosksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmptyRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional google.protobuf.Empty empty_request = 1;
 * @return {?proto.google.protobuf.Empty}
 */
proto.kioskPB.GetKiosksRequest.prototype.getEmptyRequest = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 1));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.kioskPB.GetKiosksRequest} returns this
*/
proto.kioskPB.GetKiosksRequest.prototype.setEmptyRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.kioskPB.GetKiosksRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.GetKiosksRequest} returns this
 */
proto.kioskPB.GetKiosksRequest.prototype.clearEmptyRequest = function() {
  return this.setEmptyRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.GetKiosksRequest.prototype.hasEmptyRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string kiosk_id = 2;
 * @return {string}
 */
proto.kioskPB.GetKiosksRequest.prototype.getKioskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.GetKiosksRequest} returns this
 */
proto.kioskPB.GetKiosksRequest.prototype.setKioskId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.kioskPB.GetKiosksRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.kioskPB.GetKiosksRequest} returns this
 */
proto.kioskPB.GetKiosksRequest.prototype.clearKioskId = function() {
  return jspb.Message.setOneofField(this, 2, proto.kioskPB.GetKiosksRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.GetKiosksRequest.prototype.hasKioskId = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.kioskPB.GetKiosksResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.kioskPB.GetKiosksResponse.ResponseTypeCase = {
  RESPONSE_TYPE_NOT_SET: 0,
  SINGLE_KIOSK: 1,
  MULTIPLE_KIOSKS: 2
};

/**
 * @return {proto.kioskPB.GetKiosksResponse.ResponseTypeCase}
 */
proto.kioskPB.GetKiosksResponse.prototype.getResponseTypeCase = function() {
  return /** @type {proto.kioskPB.GetKiosksResponse.ResponseTypeCase} */(jspb.Message.computeOneofCase(this, proto.kioskPB.GetKiosksResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kioskPB.GetKiosksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.kioskPB.GetKiosksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kioskPB.GetKiosksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.GetKiosksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
singleKiosk: (f = msg.getSingleKiosk()) && proto.kioskPB.Kiosk.toObject(includeInstance, f),
multipleKiosks: (f = msg.getMultipleKiosks()) && proto.kioskPB.KiosksList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kioskPB.GetKiosksResponse}
 */
proto.kioskPB.GetKiosksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kioskPB.GetKiosksResponse;
  return proto.kioskPB.GetKiosksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kioskPB.GetKiosksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kioskPB.GetKiosksResponse}
 */
proto.kioskPB.GetKiosksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.kioskPB.Kiosk;
      reader.readMessage(value,proto.kioskPB.Kiosk.deserializeBinaryFromReader);
      msg.setSingleKiosk(value);
      break;
    case 2:
      var value = new proto.kioskPB.KiosksList;
      reader.readMessage(value,proto.kioskPB.KiosksList.deserializeBinaryFromReader);
      msg.setMultipleKiosks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kioskPB.GetKiosksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kioskPB.GetKiosksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kioskPB.GetKiosksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.GetKiosksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSingleKiosk();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.kioskPB.Kiosk.serializeBinaryToWriter
    );
  }
  f = message.getMultipleKiosks();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.kioskPB.KiosksList.serializeBinaryToWriter
    );
  }
};


/**
 * optional Kiosk single_kiosk = 1;
 * @return {?proto.kioskPB.Kiosk}
 */
proto.kioskPB.GetKiosksResponse.prototype.getSingleKiosk = function() {
  return /** @type{?proto.kioskPB.Kiosk} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Kiosk, 1));
};


/**
 * @param {?proto.kioskPB.Kiosk|undefined} value
 * @return {!proto.kioskPB.GetKiosksResponse} returns this
*/
proto.kioskPB.GetKiosksResponse.prototype.setSingleKiosk = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.kioskPB.GetKiosksResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.GetKiosksResponse} returns this
 */
proto.kioskPB.GetKiosksResponse.prototype.clearSingleKiosk = function() {
  return this.setSingleKiosk(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.GetKiosksResponse.prototype.hasSingleKiosk = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional KiosksList multiple_kiosks = 2;
 * @return {?proto.kioskPB.KiosksList}
 */
proto.kioskPB.GetKiosksResponse.prototype.getMultipleKiosks = function() {
  return /** @type{?proto.kioskPB.KiosksList} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.KiosksList, 2));
};


/**
 * @param {?proto.kioskPB.KiosksList|undefined} value
 * @return {!proto.kioskPB.GetKiosksResponse} returns this
*/
proto.kioskPB.GetKiosksResponse.prototype.setMultipleKiosks = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.kioskPB.GetKiosksResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.GetKiosksResponse} returns this
 */
proto.kioskPB.GetKiosksResponse.prototype.clearMultipleKiosks = function() {
  return this.setMultipleKiosks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.GetKiosksResponse.prototype.hasMultipleKiosks = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kioskPB.Address.prototype.toObject = function(opt_includeInstance) {
  return proto.kioskPB.Address.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kioskPB.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.Address.toObject = function(includeInstance, msg) {
  var f, obj = {
formattedaddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
location: (f = msg.getLocation()) && proto.kioskPB.Location.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kioskPB.Address}
 */
proto.kioskPB.Address.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kioskPB.Address;
  return proto.kioskPB.Address.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kioskPB.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kioskPB.Address}
 */
proto.kioskPB.Address.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormattedaddress(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.kioskPB.Location;
      reader.readMessage(value,proto.kioskPB.Location.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kioskPB.Address.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kioskPB.Address.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kioskPB.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.Address.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFormattedaddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.kioskPB.Location.serializeBinaryToWriter
    );
  }
};


/**
 * optional string formattedAddress = 1;
 * @return {string}
 */
proto.kioskPB.Address.prototype.getFormattedaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Address} returns this
 */
proto.kioskPB.Address.prototype.setFormattedaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.kioskPB.Address.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Address} returns this
 */
proto.kioskPB.Address.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Location location = 3;
 * @return {?proto.kioskPB.Location}
 */
proto.kioskPB.Address.prototype.getLocation = function() {
  return /** @type{?proto.kioskPB.Location} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Location, 3));
};


/**
 * @param {?proto.kioskPB.Location|undefined} value
 * @return {!proto.kioskPB.Address} returns this
*/
proto.kioskPB.Address.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.Address} returns this
 */
proto.kioskPB.Address.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.Address.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kioskPB.Location.prototype.toObject = function(opt_includeInstance) {
  return proto.kioskPB.Location.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kioskPB.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.Location.toObject = function(includeInstance, msg) {
  var f, obj = {
lat: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
lng: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kioskPB.Location}
 */
proto.kioskPB.Location.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kioskPB.Location;
  return proto.kioskPB.Location.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kioskPB.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kioskPB.Location}
 */
proto.kioskPB.Location.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLat(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLng(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kioskPB.Location.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kioskPB.Location.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kioskPB.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.Location.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLat();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLng();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double lat = 1;
 * @return {number}
 */
proto.kioskPB.Location.prototype.getLat = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.kioskPB.Location} returns this
 */
proto.kioskPB.Location.prototype.setLat = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double lng = 2;
 * @return {number}
 */
proto.kioskPB.Location.prototype.getLng = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.kioskPB.Location} returns this
 */
proto.kioskPB.Location.prototype.setLng = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.kioskPB.Kiosk.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kioskPB.Kiosk.prototype.toObject = function(opt_includeInstance) {
  return proto.kioskPB.Kiosk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kioskPB.Kiosk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.Kiosk.toObject = function(includeInstance, msg) {
  var f, obj = {
kioskid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
model: jspb.Message.getFieldWithDefault(msg, 3, ""),
status: jspb.Message.getFieldWithDefault(msg, 4, ""),
kioskgroup: jspb.Message.getFieldWithDefault(msg, 5, ""),
capacity: jspb.Message.getFieldWithDefault(msg, 6, 0),
address: (f = msg.getAddress()) && proto.kioskPB.Address.toObject(includeInstance, f),
organizationid: jspb.Message.getFieldWithDefault(msg, 8, ""),
userid: jspb.Message.getFieldWithDefault(msg, 9, ""),
chargedbattery: jspb.Message.getFieldWithDefault(msg, 10, 0),
imageStringList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
description: jspb.Message.getFieldWithDefault(msg, 12, ""),
availabilityschedule: (f = msg.getAvailabilityschedule()) && proto.kioskPB.AvailabilitySchedule.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kioskPB.Kiosk}
 */
proto.kioskPB.Kiosk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kioskPB.Kiosk;
  return proto.kioskPB.Kiosk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kioskPB.Kiosk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kioskPB.Kiosk}
 */
proto.kioskPB.Kiosk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKioskid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setKioskgroup(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCapacity(value);
      break;
    case 7:
      var value = new proto.kioskPB.Address;
      reader.readMessage(value,proto.kioskPB.Address.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChargedbattery(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addImageString(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 13:
      var value = new proto.kioskPB.AvailabilitySchedule;
      reader.readMessage(value,proto.kioskPB.AvailabilitySchedule.deserializeBinaryFromReader);
      msg.setAvailabilityschedule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kioskPB.Kiosk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kioskPB.Kiosk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kioskPB.Kiosk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.Kiosk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKioskid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getKioskgroup();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCapacity();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.kioskPB.Address.serializeBinaryToWriter
    );
  }
  f = message.getOrganizationid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getChargedbattery();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getImageStringList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAvailabilityschedule();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.kioskPB.AvailabilitySchedule.serializeBinaryToWriter
    );
  }
};


/**
 * optional string kioskId = 1;
 * @return {string}
 */
proto.kioskPB.Kiosk.prototype.getKioskid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setKioskid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.kioskPB.Kiosk.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string model = 3;
 * @return {string}
 */
proto.kioskPB.Kiosk.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.kioskPB.Kiosk.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string kioskGroup = 5;
 * @return {string}
 */
proto.kioskPB.Kiosk.prototype.getKioskgroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setKioskgroup = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 capacity = 6;
 * @return {number}
 */
proto.kioskPB.Kiosk.prototype.getCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setCapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional Address address = 7;
 * @return {?proto.kioskPB.Address}
 */
proto.kioskPB.Kiosk.prototype.getAddress = function() {
  return /** @type{?proto.kioskPB.Address} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Address, 7));
};


/**
 * @param {?proto.kioskPB.Address|undefined} value
 * @return {!proto.kioskPB.Kiosk} returns this
*/
proto.kioskPB.Kiosk.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.Kiosk.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string organizationId = 8;
 * @return {string}
 */
proto.kioskPB.Kiosk.prototype.getOrganizationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setOrganizationid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string userId = 9;
 * @return {string}
 */
proto.kioskPB.Kiosk.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 chargedBattery = 10;
 * @return {number}
 */
proto.kioskPB.Kiosk.prototype.getChargedbattery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setChargedbattery = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * repeated string image_string = 11;
 * @return {!Array<string>}
 */
proto.kioskPB.Kiosk.prototype.getImageStringList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setImageStringList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.addImageString = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.clearImageStringList = function() {
  return this.setImageStringList([]);
};


/**
 * optional string description = 12;
 * @return {string}
 */
proto.kioskPB.Kiosk.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional AvailabilitySchedule availabilitySchedule = 13;
 * @return {?proto.kioskPB.AvailabilitySchedule}
 */
proto.kioskPB.Kiosk.prototype.getAvailabilityschedule = function() {
  return /** @type{?proto.kioskPB.AvailabilitySchedule} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.AvailabilitySchedule, 13));
};


/**
 * @param {?proto.kioskPB.AvailabilitySchedule|undefined} value
 * @return {!proto.kioskPB.Kiosk} returns this
*/
proto.kioskPB.Kiosk.prototype.setAvailabilityschedule = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.Kiosk} returns this
 */
proto.kioskPB.Kiosk.prototype.clearAvailabilityschedule = function() {
  return this.setAvailabilityschedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.Kiosk.prototype.hasAvailabilityschedule = function() {
  return jspb.Message.getField(this, 13) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.kioskPB.KioskSummary.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kioskPB.KioskSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.kioskPB.KioskSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kioskPB.KioskSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.KioskSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
kioskid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
model: jspb.Message.getFieldWithDefault(msg, 3, ""),
status: jspb.Message.getFieldWithDefault(msg, 4, ""),
kioskgroup: jspb.Message.getFieldWithDefault(msg, 5, ""),
capacity: jspb.Message.getFieldWithDefault(msg, 6, 0),
address: (f = msg.getAddress()) && proto.kioskPB.Address.toObject(includeInstance, f),
organizationid: jspb.Message.getFieldWithDefault(msg, 8, ""),
userid: jspb.Message.getFieldWithDefault(msg, 9, ""),
chargedbattery: jspb.Message.getFieldWithDefault(msg, 10, 0),
description: jspb.Message.getFieldWithDefault(msg, 11, ""),
availabilityschedule: (f = msg.getAvailabilityschedule()) && proto.kioskPB.AvailabilitySchedule.toObject(includeInstance, f),
thumbnailList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kioskPB.KioskSummary}
 */
proto.kioskPB.KioskSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kioskPB.KioskSummary;
  return proto.kioskPB.KioskSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kioskPB.KioskSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kioskPB.KioskSummary}
 */
proto.kioskPB.KioskSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKioskid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setKioskgroup(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCapacity(value);
      break;
    case 7:
      var value = new proto.kioskPB.Address;
      reader.readMessage(value,proto.kioskPB.Address.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChargedbattery(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 12:
      var value = new proto.kioskPB.AvailabilitySchedule;
      reader.readMessage(value,proto.kioskPB.AvailabilitySchedule.deserializeBinaryFromReader);
      msg.setAvailabilityschedule(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addThumbnail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kioskPB.KioskSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kioskPB.KioskSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kioskPB.KioskSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.KioskSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKioskid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getKioskgroup();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCapacity();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.kioskPB.Address.serializeBinaryToWriter
    );
  }
  f = message.getOrganizationid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getChargedbattery();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAvailabilityschedule();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.kioskPB.AvailabilitySchedule.serializeBinaryToWriter
    );
  }
  f = message.getThumbnailList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
};


/**
 * optional string kioskId = 1;
 * @return {string}
 */
proto.kioskPB.KioskSummary.prototype.getKioskid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setKioskid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.kioskPB.KioskSummary.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string model = 3;
 * @return {string}
 */
proto.kioskPB.KioskSummary.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.kioskPB.KioskSummary.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string kioskGroup = 5;
 * @return {string}
 */
proto.kioskPB.KioskSummary.prototype.getKioskgroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setKioskgroup = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 capacity = 6;
 * @return {number}
 */
proto.kioskPB.KioskSummary.prototype.getCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setCapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional Address address = 7;
 * @return {?proto.kioskPB.Address}
 */
proto.kioskPB.KioskSummary.prototype.getAddress = function() {
  return /** @type{?proto.kioskPB.Address} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Address, 7));
};


/**
 * @param {?proto.kioskPB.Address|undefined} value
 * @return {!proto.kioskPB.KioskSummary} returns this
*/
proto.kioskPB.KioskSummary.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.KioskSummary.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string organizationId = 8;
 * @return {string}
 */
proto.kioskPB.KioskSummary.prototype.getOrganizationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setOrganizationid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string userId = 9;
 * @return {string}
 */
proto.kioskPB.KioskSummary.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 chargedBattery = 10;
 * @return {number}
 */
proto.kioskPB.KioskSummary.prototype.getChargedbattery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setChargedbattery = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string description = 11;
 * @return {string}
 */
proto.kioskPB.KioskSummary.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional AvailabilitySchedule availabilitySchedule = 12;
 * @return {?proto.kioskPB.AvailabilitySchedule}
 */
proto.kioskPB.KioskSummary.prototype.getAvailabilityschedule = function() {
  return /** @type{?proto.kioskPB.AvailabilitySchedule} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.AvailabilitySchedule, 12));
};


/**
 * @param {?proto.kioskPB.AvailabilitySchedule|undefined} value
 * @return {!proto.kioskPB.KioskSummary} returns this
*/
proto.kioskPB.KioskSummary.prototype.setAvailabilityschedule = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.clearAvailabilityschedule = function() {
  return this.setAvailabilityschedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.KioskSummary.prototype.hasAvailabilityschedule = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated string Thumbnail = 13;
 * @return {!Array<string>}
 */
proto.kioskPB.KioskSummary.prototype.getThumbnailList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.setThumbnailList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.addThumbnail = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.kioskPB.KioskSummary} returns this
 */
proto.kioskPB.KioskSummary.prototype.clearThumbnailList = function() {
  return this.setThumbnailList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.kioskPB.KiosksList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kioskPB.KiosksList.prototype.toObject = function(opt_includeInstance) {
  return proto.kioskPB.KiosksList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kioskPB.KiosksList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.KiosksList.toObject = function(includeInstance, msg) {
  var f, obj = {
kiosksList: jspb.Message.toObjectList(msg.getKiosksList(),
    proto.kioskPB.KioskSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kioskPB.KiosksList}
 */
proto.kioskPB.KiosksList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kioskPB.KiosksList;
  return proto.kioskPB.KiosksList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kioskPB.KiosksList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kioskPB.KiosksList}
 */
proto.kioskPB.KiosksList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.kioskPB.KioskSummary;
      reader.readMessage(value,proto.kioskPB.KioskSummary.deserializeBinaryFromReader);
      msg.addKiosks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kioskPB.KiosksList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kioskPB.KiosksList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kioskPB.KiosksList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.KiosksList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKiosksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.kioskPB.KioskSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated KioskSummary kiosks = 1;
 * @return {!Array<!proto.kioskPB.KioskSummary>}
 */
proto.kioskPB.KiosksList.prototype.getKiosksList = function() {
  return /** @type{!Array<!proto.kioskPB.KioskSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.kioskPB.KioskSummary, 1));
};


/**
 * @param {!Array<!proto.kioskPB.KioskSummary>} value
 * @return {!proto.kioskPB.KiosksList} returns this
*/
proto.kioskPB.KiosksList.prototype.setKiosksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.kioskPB.KioskSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.kioskPB.KioskSummary}
 */
proto.kioskPB.KiosksList.prototype.addKiosks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.kioskPB.KioskSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.kioskPB.KiosksList} returns this
 */
proto.kioskPB.KiosksList.prototype.clearKiosksList = function() {
  return this.setKiosksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kioskPB.AvailabilitySchedule.prototype.toObject = function(opt_includeInstance) {
  return proto.kioskPB.AvailabilitySchedule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kioskPB.AvailabilitySchedule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.AvailabilitySchedule.toObject = function(includeInstance, msg) {
  var f, obj = {
monday: (f = msg.getMonday()) && proto.kioskPB.Availability.toObject(includeInstance, f),
tuesday: (f = msg.getTuesday()) && proto.kioskPB.Availability.toObject(includeInstance, f),
wednesday: (f = msg.getWednesday()) && proto.kioskPB.Availability.toObject(includeInstance, f),
thursday: (f = msg.getThursday()) && proto.kioskPB.Availability.toObject(includeInstance, f),
friday: (f = msg.getFriday()) && proto.kioskPB.Availability.toObject(includeInstance, f),
saturday: (f = msg.getSaturday()) && proto.kioskPB.Availability.toObject(includeInstance, f),
sunday: (f = msg.getSunday()) && proto.kioskPB.Availability.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kioskPB.AvailabilitySchedule}
 */
proto.kioskPB.AvailabilitySchedule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kioskPB.AvailabilitySchedule;
  return proto.kioskPB.AvailabilitySchedule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kioskPB.AvailabilitySchedule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kioskPB.AvailabilitySchedule}
 */
proto.kioskPB.AvailabilitySchedule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.kioskPB.Availability;
      reader.readMessage(value,proto.kioskPB.Availability.deserializeBinaryFromReader);
      msg.setMonday(value);
      break;
    case 2:
      var value = new proto.kioskPB.Availability;
      reader.readMessage(value,proto.kioskPB.Availability.deserializeBinaryFromReader);
      msg.setTuesday(value);
      break;
    case 3:
      var value = new proto.kioskPB.Availability;
      reader.readMessage(value,proto.kioskPB.Availability.deserializeBinaryFromReader);
      msg.setWednesday(value);
      break;
    case 4:
      var value = new proto.kioskPB.Availability;
      reader.readMessage(value,proto.kioskPB.Availability.deserializeBinaryFromReader);
      msg.setThursday(value);
      break;
    case 5:
      var value = new proto.kioskPB.Availability;
      reader.readMessage(value,proto.kioskPB.Availability.deserializeBinaryFromReader);
      msg.setFriday(value);
      break;
    case 6:
      var value = new proto.kioskPB.Availability;
      reader.readMessage(value,proto.kioskPB.Availability.deserializeBinaryFromReader);
      msg.setSaturday(value);
      break;
    case 7:
      var value = new proto.kioskPB.Availability;
      reader.readMessage(value,proto.kioskPB.Availability.deserializeBinaryFromReader);
      msg.setSunday(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kioskPB.AvailabilitySchedule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kioskPB.AvailabilitySchedule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kioskPB.AvailabilitySchedule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.AvailabilitySchedule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMonday();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.kioskPB.Availability.serializeBinaryToWriter
    );
  }
  f = message.getTuesday();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.kioskPB.Availability.serializeBinaryToWriter
    );
  }
  f = message.getWednesday();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.kioskPB.Availability.serializeBinaryToWriter
    );
  }
  f = message.getThursday();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.kioskPB.Availability.serializeBinaryToWriter
    );
  }
  f = message.getFriday();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.kioskPB.Availability.serializeBinaryToWriter
    );
  }
  f = message.getSaturday();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.kioskPB.Availability.serializeBinaryToWriter
    );
  }
  f = message.getSunday();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.kioskPB.Availability.serializeBinaryToWriter
    );
  }
};


/**
 * optional Availability monday = 1;
 * @return {?proto.kioskPB.Availability}
 */
proto.kioskPB.AvailabilitySchedule.prototype.getMonday = function() {
  return /** @type{?proto.kioskPB.Availability} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Availability, 1));
};


/**
 * @param {?proto.kioskPB.Availability|undefined} value
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
*/
proto.kioskPB.AvailabilitySchedule.prototype.setMonday = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
 */
proto.kioskPB.AvailabilitySchedule.prototype.clearMonday = function() {
  return this.setMonday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.AvailabilitySchedule.prototype.hasMonday = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Availability tuesday = 2;
 * @return {?proto.kioskPB.Availability}
 */
proto.kioskPB.AvailabilitySchedule.prototype.getTuesday = function() {
  return /** @type{?proto.kioskPB.Availability} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Availability, 2));
};


/**
 * @param {?proto.kioskPB.Availability|undefined} value
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
*/
proto.kioskPB.AvailabilitySchedule.prototype.setTuesday = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
 */
proto.kioskPB.AvailabilitySchedule.prototype.clearTuesday = function() {
  return this.setTuesday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.AvailabilitySchedule.prototype.hasTuesday = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Availability wednesday = 3;
 * @return {?proto.kioskPB.Availability}
 */
proto.kioskPB.AvailabilitySchedule.prototype.getWednesday = function() {
  return /** @type{?proto.kioskPB.Availability} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Availability, 3));
};


/**
 * @param {?proto.kioskPB.Availability|undefined} value
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
*/
proto.kioskPB.AvailabilitySchedule.prototype.setWednesday = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
 */
proto.kioskPB.AvailabilitySchedule.prototype.clearWednesday = function() {
  return this.setWednesday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.AvailabilitySchedule.prototype.hasWednesday = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Availability thursday = 4;
 * @return {?proto.kioskPB.Availability}
 */
proto.kioskPB.AvailabilitySchedule.prototype.getThursday = function() {
  return /** @type{?proto.kioskPB.Availability} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Availability, 4));
};


/**
 * @param {?proto.kioskPB.Availability|undefined} value
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
*/
proto.kioskPB.AvailabilitySchedule.prototype.setThursday = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
 */
proto.kioskPB.AvailabilitySchedule.prototype.clearThursday = function() {
  return this.setThursday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.AvailabilitySchedule.prototype.hasThursday = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Availability friday = 5;
 * @return {?proto.kioskPB.Availability}
 */
proto.kioskPB.AvailabilitySchedule.prototype.getFriday = function() {
  return /** @type{?proto.kioskPB.Availability} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Availability, 5));
};


/**
 * @param {?proto.kioskPB.Availability|undefined} value
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
*/
proto.kioskPB.AvailabilitySchedule.prototype.setFriday = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
 */
proto.kioskPB.AvailabilitySchedule.prototype.clearFriday = function() {
  return this.setFriday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.AvailabilitySchedule.prototype.hasFriday = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Availability saturday = 6;
 * @return {?proto.kioskPB.Availability}
 */
proto.kioskPB.AvailabilitySchedule.prototype.getSaturday = function() {
  return /** @type{?proto.kioskPB.Availability} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Availability, 6));
};


/**
 * @param {?proto.kioskPB.Availability|undefined} value
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
*/
proto.kioskPB.AvailabilitySchedule.prototype.setSaturday = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
 */
proto.kioskPB.AvailabilitySchedule.prototype.clearSaturday = function() {
  return this.setSaturday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.AvailabilitySchedule.prototype.hasSaturday = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Availability sunday = 7;
 * @return {?proto.kioskPB.Availability}
 */
proto.kioskPB.AvailabilitySchedule.prototype.getSunday = function() {
  return /** @type{?proto.kioskPB.Availability} */ (
    jspb.Message.getWrapperField(this, proto.kioskPB.Availability, 7));
};


/**
 * @param {?proto.kioskPB.Availability|undefined} value
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
*/
proto.kioskPB.AvailabilitySchedule.prototype.setSunday = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.kioskPB.AvailabilitySchedule} returns this
 */
proto.kioskPB.AvailabilitySchedule.prototype.clearSunday = function() {
  return this.setSunday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.kioskPB.AvailabilitySchedule.prototype.hasSunday = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.kioskPB.Availability.prototype.toObject = function(opt_includeInstance) {
  return proto.kioskPB.Availability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.kioskPB.Availability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.Availability.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
start: jspb.Message.getFieldWithDefault(msg, 2, ""),
end: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.kioskPB.Availability}
 */
proto.kioskPB.Availability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.kioskPB.Availability;
  return proto.kioskPB.Availability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.kioskPB.Availability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.kioskPB.Availability}
 */
proto.kioskPB.Availability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStart(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.kioskPB.Availability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.kioskPB.Availability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.kioskPB.Availability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.kioskPB.Availability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getStart();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnd();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.kioskPB.Availability.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.kioskPB.Availability} returns this
 */
proto.kioskPB.Availability.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string start = 2;
 * @return {string}
 */
proto.kioskPB.Availability.prototype.getStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Availability} returns this
 */
proto.kioskPB.Availability.prototype.setStart = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string end = 3;
 * @return {string}
 */
proto.kioskPB.Availability.prototype.getEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.kioskPB.Availability} returns this
 */
proto.kioskPB.Availability.prototype.setEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.kioskPB);
